"use strict";

var _regeneratorRuntime = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FDSSwarm = _interopRequireDefault(require("./FDS-Swarm.js"));

var _Multibox = _interopRequireDefault(require("./contracts/Multibox.js"));

var _KeyValueTree = _interopRequireDefault(require("./contracts/KeyValueTree.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Multibox =
/*#__PURE__*/
function () {
  function Multibox(account, config) {
    _classCallCheck(this, Multibox);

    this.account = account;
    this.con = null;
    this.roots = null;
    this.contractAddress = null;
    this.rootKvt = null;
    this.kvts = null;
    this.Store = new _FDSSwarm.default(config, account);
  }

  _createClass(Multibox, [{
    key: "at",
    value: function at(address) {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _Multibox.default(_this.account, address);

              case 2:
                _this.mb = _context.sent;
                _this.contractAddress = address;
                _context.next = 6;
                return _this.mb.getRoots();

              case 6:
                _this.roots = _context.sent;
                _this.rootKvt = new _KeyValueTree.default(_this.account, _this.roots[0]);
                _this.kvts = _this.roots.map(function (root) {
                  return new _KeyValueTree.default(_this.account, root);
                });
                return _context.abrupt("return", _this);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, {
    key: "deploy",
    value: function deploy() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new _Multibox.default(_this2.account);

              case 2:
                _this2.mb = _context2.sent;
                _this2.contractAddress = _this2.mb.contractAddress;
                _context2.next = 6;
                return _this2.mb.getRoots();

              case 6:
                _this2.roots = _context2.sent;
                _this2.rootKvt = new _KeyValueTree.default(_this2.account, _this2.roots[0]);
                _this2.kvts = _this2.roots.map(function (root) {
                  return new _KeyValueTree.default(_this2.account, root);
                });
                return _context2.abrupt("return", _this2);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    } // note - we should use something other than swarm digest id's here eg. encrypted strings in multibox contract
    // it's unnecessarily expensive and also prone requires swarm hashes to be available from network in order to work
    // note - would be good to check these in reverse to avoid unneccesary calls

  }, {
    key: "get",
    value: function get(path) {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var retrievePathNames;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                retrievePathNames = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
                return _context3.abrupt("return", _this3.retrievePathValues(path, retrievePathNames));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }, {
    key: "set",
    value: function set(path, key, value) {
      var _this4 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var nodeId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.createPath(path);

              case 2:
                _context4.next = 4;
                return _this4.Store.getSwarmDigest(path);

              case 4:
                nodeId = _context4.sent;
                return _context4.abrupt("return", _this4.rootKvt.setKeyValue(nodeId, key, value));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }, {
    key: "createPath",
    value: function createPath(path, value) {
      var _arguments2 = arguments,
          _this5 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var kvti, parentNodeId, splitPath, i, currentPath, newNodeId, addChildNode;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                kvti = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : 0;
                splitPath = path.split('/').slice(1);

                if (!(splitPath[0] === 'root')) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return _this5.rootKvt.getRootId();

              case 5:
                parentNodeId = _context5.sent;
                _context5.next = 15;
                break;

              case 8:
                if (!(splitPath[0] === 'shared')) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 11;
                return _this5.rootKvt.getSharedId();

              case 11:
                parentNodeId = _context5.sent;
                _context5.next = 15;
                break;

              case 14:
                throw new Error('path must begin /shared or /root');

              case 15:
                i = 0;

              case 16:
                if (!(i < splitPath.length - 1)) {
                  _context5.next = 28;
                  break;
                }

                currentPath = '/' + splitPath.slice(0, i + 2).join('/');
                _context5.next = 20;
                return _this5.Store.getSwarmDigest(currentPath);

              case 20:
                newNodeId = _context5.sent;
                _context5.next = 23;
                return _this5.rootKvt.addChildNode(parentNodeId, newNodeId);

              case 23:
                addChildNode = _context5.sent;
                parentNodeId = newNodeId;

              case 25:
                i++;
                _context5.next = 16;
                break;

              case 28:
                return _context5.abrupt("return", true);

              case 29:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }, {
    key: "retrieveValues",
    value: function retrieveValues(nodeId) {
      var _this6 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var keyValues, keyValuesRaw, i;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                keyValues = {};
                _context6.next = 3;
                return _this6.rootKvt.getKeyValues(nodeId);

              case 3:
                keyValuesRaw = _context6.sent;

                for (i = 0; i < keyValuesRaw['keys'].length; i++) {
                  keyValues[keyValuesRaw['keys'][i]] = keyValuesRaw['values'][i];
                }

                return _context6.abrupt("return", keyValues);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }, {
    key: "retrieveTree",
    value: function retrieveTree(nodeId) {
      var _arguments3 = arguments,
          _this7 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var values, retrievePathNames, output, children, pathName;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                values = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : false;
                retrievePathNames = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : false;
                output = {
                  id: nodeId,
                  parentId: false
                };
                _context7.next = 5;
                return _this7.rootKvt.getChildren(nodeId);

              case 5:
                children = _context7.sent;

                if (!(retrievePathNames === true)) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 9;
                return _this7.Store.getSwarmDigestValue(nodeId);

              case 9:
                pathName = _context7.sent;
                output.name = pathName;

              case 11:
                if (!(children.length === 0 && values === false)) {
                  _context7.next = 15;
                  break;
                }

                output = {
                  id: nodeId,
                  parentId: false
                };
                _context7.next = 27;
                break;

              case 15:
                if (!(children.length === 0 && values === true)) {
                  _context7.next = 21;
                  break;
                }

                _context7.next = 18;
                return _this7.retrieveValues(nodeId);

              case 18:
                output.values = _context7.sent;
                _context7.next = 27;
                break;

              case 21:
                _context7.next = 23;
                return _this7.retrieveValues(nodeId);

              case 23:
                output.values = _context7.sent;
                _context7.next = 26;
                return _this7.retrievesDescendants(nodeId, values, retrievePathNames);

              case 26:
                output.children = _context7.sent;

              case 27:
                return _context7.abrupt("return", output);

              case 28:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  }, {
    key: "retrievesDescendants",
    value: function retrievesDescendants(nodeId) {
      var _arguments4 = arguments,
          _this8 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var values, retrievePathNames, children, output, i, descendants, childOutput, pathName, keyValues;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                values = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : false;
                retrievePathNames = _arguments4.length > 2 && _arguments4[2] !== undefined ? _arguments4[2] : false;
                _context8.next = 4;
                return _this8.rootKvt.getChildren(nodeId);

              case 4:
                children = _context8.sent;
                output = [];
                i = 0;

              case 7:
                if (!(i < children.length)) {
                  _context8.next = 32;
                  break;
                }

                _context8.next = 10;
                return _this8.retrievesDescendants(children[i], values, retrievePathNames);

              case 10:
                descendants = _context8.sent;
                childOutput = {
                  id: children[i],
                  parentId: nodeId
                };

                if (!(retrievePathNames === true)) {
                  _context8.next = 17;
                  break;
                }

                _context8.next = 15;
                return _this8.Store.getSwarmDigestValue(children[i]);

              case 15:
                pathName = _context8.sent;
                childOutput.name = pathName;

              case 17:
                if (!(descendants.length > 0)) {
                  _context8.next = 22;
                  break;
                }

                childOutput.children = descendants;
                output.push(childOutput);
                _context8.next = 29;
                break;

              case 22:
                keyValues = {};

                if (!(values === true)) {
                  _context8.next = 27;
                  break;
                }

                _context8.next = 26;
                return _this8.retrieveValues(children[i]);

              case 26:
                keyValues = _context8.sent;

              case 27:
                childOutput.values = keyValues;
                output.push(childOutput);

              case 29:
                i++;
                _context8.next = 7;
                break;

              case 32:
                return _context8.abrupt("return", output);

              case 33:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    } // retrieves tree structure only of path eg. /shared/mail

  }, {
    key: "retrievePathNodes",
    value: function retrievePathNodes(path) {
      var _this9 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var nodeId;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.Store.getSwarmDigest(path);

              case 2:
                nodeId = _context9.sent;
                _context9.next = 5;
                return _this9.retrieveTree(nodeId, false, false);

              case 5:
                return _context9.abrupt("return", _context9.sent);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    } // retrieves tree structure and keyvalues of path eg. /shared/mail

  }, {
    key: "retrievePathValues",
    value: function retrievePathValues(path, retrievePathNames) {
      var _this10 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var nodeId;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this10.Store.getSwarmDigest(path);

              case 2:
                nodeId = _context10.sent;
                _context10.next = 5;
                return _this10.retrieveTree(nodeId, true, retrievePathNames);

              case 5:
                return _context10.abrupt("return", _context10.sent);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  }]);

  return Multibox;
}();

var _default = Multibox;
exports.default = _default;
module.exports = exports.default;